goog.provide("shadow.js.shim.module$$mui$material$Select");
goog.provide("module$shadow_js_shim_module$$mui$material$Select");
shadow.js.shim.module$$mui$material$Select = shadow.js.nativeProvides["@mui/material/Select"] = shadow$bridge("@mui/material/Select");
module$shadow_js_shim_module$$mui$material$Select.default = shadow.js.shim.module$$mui$material$Select;
